import { AfterViewInit, Directive } from '@angular/core';
import { ScrollPositionRestorationService } from './scroll-position-restoration.service';

/**
 * Добавляется к компоненту, который последним отрисовывается на
 * странице (например после длительной загрузки данных). После чего
 * принудительно восстанавливает позицию скролла, если пользователь
 * уже был на данной странице.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[uiRestoreScrollPosition]',
  standalone: true,
})
export class RestoreScrollPositionDirective implements AfterViewInit {
  constructor(private scrollPositionRestorationService: ScrollPositionRestorationService) {}

  ngAfterViewInit(): void {
    this.scrollPositionRestorationService.forceRestoreScrollPosition();
  }
}
